import styled from 'styled-components';

const Prefix = styled.div`
    font-size: 1rem;
    color: #666666;
`;

export default Prefix;
